import { Box, Typography, IconButton, SxProps, Theme } from 'ui/mui';
import HorizontalLogo from 'ui/components/logo/HorizontalLogo';
import { darkModeColors } from 'ui/theme/theme';
import { FooterLink } from './FooterLink';
import {
  IconFacebook,
  IconInstagram,
  IconYouTube,
  IconLinkedIn,
} from 'ui/Icons';

type FooterLogoSectionProps = {
  sx?: SxProps<Theme>;
};

export const FooterLogoSection = ({ sx }: FooterLogoSectionProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: 4,
        ...sx,
      }}
    >
      <Box>
        <HorizontalLogo textColor={darkModeColors.text.primary} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
            gap: { xs: 2, sm: 2, lg: 4 },
            mt: 2,
            alignItems: { xs: 'flex-start', sm: 'flex-start', lg: 'center' },
            justifyContent: { xs: 'flex-start', lg: 'space-between' },
          }}
        >
          <Box sx={{ width: { xs: '100%', lg: '50%' } }}>
            <Typography variant='body2'>
              Mälarenergi levererar grundläggande funktioner som energi-,
              vatten- och bredbandslösningar för ett levande samhälle och
              blomstrande näringsliv.
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1,
              ml: { xs: 0, lg: 'auto' },
              alignItems: { xs: 'flex-start', sm: 'center' },
              '& > a': {
                display: 'flex',
                alignItems: 'center',
              },
              '& > a > svg': {
                mr: 1,
              },
            }}
          >
            <FooterLink
              href='https://www.facebook.com/malarenergi/'
              external={true}
            >
              <IconFacebook sx={{ color: darkModeColors.text.primary }} />
              Facebook
            </FooterLink>
            <FooterLink
              href='https://www.instagram.com/malarenergi/'
              external={true}
            >
              <IconInstagram sx={{ color: darkModeColors.text.primary }} />
              Instagram
            </FooterLink>
            <FooterLink
              href='https://www.youtube.com/user/malarenergi'
              external={true}
            >
              <IconYouTube sx={{ color: darkModeColors.text.primary }} />
              Youtube
            </FooterLink>
            <FooterLink
              href='https://www.linkedin.com/company/malarenergi'
              external={true}
            >
              <IconLinkedIn sx={{ color: darkModeColors.text.primary }} />
              Linkedin
            </FooterLink>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
